export default {
  name: 'report-hashtag',
  components: {},
  props: [],
  data () {
    return {
      normalizer (node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        }
      },
      statusNormalizer (node) {
        return {
          id: node.id,
          label: node.code,
          children: node.children
        }
      },
      status: null,
      loading: true,
      from_date: '',
      to_date: '',
      errors: [],
      org_id: null,
      hash_tag: [],
      report_hashtag: []
    }
  },
  computed: {
    organizations () {
      return this.$store.getters['Organization/getOrganization']
    },
    list_status () {
      return this.$store.getters['ChecklistItemStatus/getListStatus']
    },
    tags () {
      return this.$store.getters['Tag/getListTag']
    },
  },
  mounted () {
  
    Promise.all([
      this.$store.dispatch('Organization/getData', {page: 1, per_page: 'all'}),
      this.$store.dispatch('ChecklistItemStatus/getListStatus'),
      this.$store.dispatch('Tag/getListTag', {page: 1, per_page: 'all'})
    ]).then(() => {
      
      this.loading = false
    }).catch(errors => {
      
      this.loading = false
    })
  },
  methods: {
    report () {
      if (!this.org_id) {
        this.errors = {
          org_id: [
            'organization_id is required'
          ]
        }
        return false
      }
      var data = {}
      this.report_hashtag = []
      data.from_date = this.from_date
      data.to_date = this.to_date
      data.stt = this.status
      data.hashtag = this.hash_tag
      data.org_id = this.org_id
    
      this.$store.dispatch('Report/hashtagReport', {data}).then(res => {
        this.report_hashtag.push(res.chk_items)
        this.errors = []
        
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/report-hashtag/report-hashtag.js